import { Parser } from 'html-to-react'

import { cleanHTML } from '@/utils/utils'

import styles from './EditorHtml.module.scss'

const htmlToReactParser = new Parser()

const EditorHtml = ({
  as: Component = 'div',
  className = '',
  compact = false,
  content,
  ...props
}) => {
  const cleanedContent = cleanHTML(content)

  if (!cleanedContent) {
    return null
  }

  return (
    <Component
      className={`${styles.editorHtml} ${compact ? styles.compact : ''} ${className}`.trim()}
      {...props}
    >
      {htmlToReactParser.parse(cleanedContent)}
    </Component>
  )
}

export default EditorHtml